import InternalReporting from "./pages/internal-reporting";

const InternalReportingRoutes = [
  {
    path: "/internal-reporting",
    element: <InternalReporting />,
  },
];

export default InternalReportingRoutes;
